
define('text!presentation/login/views/resendInvite.html',[],function () { return '<div class="login-resend-invite__text"\n     data-bind="i18n: {\n                    key: \'inviteSentMessage\',\n                    options: { expirationDate: inviteExpirationDate }\n                }">\n</div>';});

